/* eslint-disable global-require */
const List = () => import('./main.vue');

export default [
  {
    name: 'relatorio/titulos-emitidos-abertos-data-pagamento-superior',
    path: '/relatorio/titulos-emitidos-abertos-data-pagamento-superior',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Títulos Emitidos Em Aberto Ou Data Pagamento Superior',
      icon: 'file',
      can: 'rep271',
      on: 'report',
      client: 'copass',
    },
  },
];
